document.addEventListener('DOMContentLoaded', function() {
    var handleSpan = document.getElementById('prod-id');
    var handle = handleSpan.getAttribute('data-handle');
  
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var rvString = cart.attributes && cart.attributes.recently_viewed
          ? cart.attributes.recently_viewed
          : '';
  
        var handles = rvString ? rvString.split(',') : [];
  
        handles = handles.filter(function(h) { return h !== handle; });
  
        if (handles.length >= 5) {
          handles.pop();
        }
  
        handles.unshift(handle);
  
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              recently_viewed: handles.join(',')
            }
          })
        });
      })
      .catch(console.error);
  });
  